/**
 * @method Mixin Soap Content Socket
 * @descriotion the mixin only focus on the socket in soap
 */
import { isEmpty } from "lodash";
export default {
    computed: {
        currentFocusedElementId() {
            return this.$store.getters["soap/currentFocusedElementId"];
        }
    },
    methods: {
        /**
         * handleSocketMessage
         * Called from soap-content.vue and new-snippet.vue
         * To optimise this socket,maybe can connect socket only once per soap instead of connect from new snippet modal and soap content
         * @param {*} message
         * @returns
         */
        handleSocketMessage(message) {
            // Skip this listener from soap-content.vue when new-snippet.vue is openned
            // VET-1484 - Issue related to the content reverted to original snippet template,
            // perhaps, the user opened the same soap on 2 different tabs, 1st page user is editing the content, 2nd page open the new snippet, when 1st page make the changes, the content not updated in 2nd page hence when 2nd page reload, it reveted to original snippet content
            // if (this.isAddSnippetOpened && this.triggeredFromSoapContent) {
            //     return;
            // }

            message = JSON.parse(message);
            var elementId = message.field;
            var element = document.getElementById(elementId);

            if (isEmpty(message) || isEmpty(this.soapSocket)) {
                return;
            }

            // VET-9124 - To check the connection of socket
            if (
                message.action === "ping-check" &&
                message.soapPageInstance === this.soapPageInstance
            ) {
                this.pingReceived = true;
                this.onPingReceived?.();
                return;
            }

            if (message.socketId != this.soapSocket.id) {
                switch (message.action) {
                    case "join":
                        if (this.currentFocusedElementId) {
                            this.soapSocket.emit("medical-note", {
                                action: "focus",
                                field: this.currentFocusedElementId,
                                by: this.$root.currentActor.id,
                                name: this.$root.currentActor.fullname,
                                vSelect: this.currentFocusedVSelect
                            });
                        }
                        break;
                    case "leave":
                        element = document.querySelector(
                            '[data-socket-id="' + message.socketId + '"]'
                        );

                        if (element) {
                            this.$store.commit(
                                "soap/removeFromLockedElements",
                                element.id
                            );

                            if (message.vSelect) {
                                let childSelect = element.querySelector(
                                    ".v-select input"
                                );
                                childSelect.style.cursor = "";
                            } else {
                                switch (element.nodeName) {
                                    case "SELECT":
                                    case "INPUT":
                                        element.disabled = false;
                                        break;
                                    case "TEXTAREA":
                                        element.tabIndex = 0;
                                        break;
                                    default:
                                        element.contentEditable = true;
                                        element.tabIndex = 0;
                                        break;
                                }
                                element.removeAttribute("data-socket-id");
                                element.style.backgroundColor = "";
                                element.style.cursor = "";
                            }

                            message.field = element.id;
                            this.showLockedMessage(message, false);
                        }

                        break;
                    case "focus":
                        if (message.by != this.$root.currentActor.id) {
                            this.$store.commit("soap/updateLockedElements", {
                                id: elementId,
                                name: message.name
                            });
                            if (element) {
                                if (message.vSelect) {
                                    let childSelect = element.querySelector(
                                        ".v-select input"
                                    );
                                    if (childSelect) {
                                        childSelect.style.cursor =
                                            "not-allowed";
                                    }
                                } else {
                                    switch (element.nodeName) {
                                        case "SELECT":
                                        case "INPUT":
                                            element.disabled = true;
                                            break;
                                        case "TEXTAREA":
                                            element.tabIndex = -1;
                                            break;
                                        default:
                                            element.contentEditable = false;
                                            element.tabIndex = -1;
                                            element.setAttribute(
                                                "disabled",
                                                "true"
                                            );
                                            break;
                                    }
                                    element.setAttribute(
                                        "data-socket-id",
                                        message.socketId
                                    );
                                    element.style.backgroundColor = "#eeeeee";
                                    element.style.cursor = "not-allowed";
                                    element.style.pointerEvents = "none";
                                }

                                this.showLockedMessage(message, true);
                            }
                        }
                        break;
                    case "out-focus":
                        this.$store.commit(
                            "soap/removeFromLockedElements",
                            elementId
                        );

                        if (element) {
                            if (message.vSelect) {
                                let childSelect = element.querySelector(
                                    ".v-select input"
                                );
                                childSelect.style.cursor = "";
                            } else {
                                switch (element.nodeName) {
                                    case "SELECT":
                                    case "INPUT":
                                        element.disabled = false;
                                        break;
                                    case "TEXTAREA":
                                        element.tabIndex = 0;
                                        break;
                                    default:
                                        element.contentEditable = true;
                                        element.setAttribute(
                                            "disabled",
                                            "false"
                                        );
                                        element.tabIndex = 0;
                                        break;
                                }
                                element.removeAttribute("data-socket-id");
                                element.style.backgroundColor = "";
                                element.style.cursor = "";
                                element.style.pointerEvents = "auto";
                            }
                            this.showLockedMessage(message, false);
                        }

                        break;
                    case "update":
                        // Adding checking message.soapPageInstance != this.soapPageInstance to make sure current page that current user is working on not trigger this socket if still has issue with disconnect socket not handle properly
                        if (
                            element &&
                            message.soapPageInstance != this.soapPageInstance
                        ) {
                            if (message.vSelect) {
                                if (message.value) {
                                    this.selectedVSelectValues[
                                        elementId
                                    ] = message.value
                                        .split("$#")
                                        .map(option => ({
                                            id: option,
                                            label: option
                                        }));
                                } else {
                                    this.selectedVSelectValues[elementId] = [];
                                }
                            } else if (element.nodeName == "SELECT") {
                                this.$set(
                                    this.selectedBFormSelectValues,
                                    message.field,
                                    message.value
                                );
                            } else if (element.nodeName == "INPUT") {
                                element.value = message.value;
                                this.$set(
                                    this.bFormInputValues,
                                    message.field,
                                    message.value
                                );
                            } else {
                                let refElement = this.$refs[
                                    "editable-" + elementId
                                ];
                                element.innerText = message.value;
                                refElement?.[0]?.updateValueThroughSocket(
                                    message.value
                                );
                            }
                        }
                        break;

                    case "locked":
                        if (message.by != this.$root.currentActor.id) {
                            this.proceedSaveUpdate = false; // from soap-content.vue
                            this.disabledAddDueBeenLocked = true; // from add snippet modal
                            let text =
                                "This medical note has been locked by " +
                                message.name +
                                ". It is now read-only.";

                            this._message(text, "warning");
                            setTimeout(() => {
                                location.reload();
                            }, 4000);
                        }
                        break;
                    case "section":
                        // SOAP.all();
                        break;
                }
            }
        },
        showLockedMessage(data, isShow) {
            let element = document.getElementById(data.field);

            if (element) {
                let closet = element
                    .closest(".soap_section")
                    .querySelector(".field-locked-message");
                if (isShow) {
                    closet.removeAttribute("hidden");
                    closet.innerText = "(Locked by " + data.name + ")";
                } else {
                    closet.setAttribute("hidden", "true");
                    closet.innerText = "";
                }
            }
        }
    }
};
